// components/CustomHandle.js
import { Handle } from '@xyflow/react';

const CustomHandle = ({ type, position, ...props }) => {
  if (position === 'none') {
    return null;
  }
  
  const handleStyle = {
    backgroundColor: '#333',
    border: '1px solid #aaa',
    width: '7px',
    height: '7px',
    borderRadius: '50%',
  };

  // Adjust position based on handle type
  switch (position) {
    case 'left':
      handleStyle.left = '-1px'; // Move left handle outside the node
      break;
    case 'right':
      handleStyle.right = '-1px'; // Move right handle outside the node
      break;
    case 'top':
      handleStyle.top = '-1px'; // Move top handle outside the node
      break;
    case 'bottom':
      handleStyle.bottom = '-1px'; // Move bottom handle outside the node
      break;
    default:
      break;
  }

  return <Handle type={type} position={position} style={handleStyle} {...props} />;
};

export default CustomHandle;